<template>
  <div>
    <template-chart :items="items" :yyyy="yyyy"></template-chart>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['items', 'yyyy'],
  computed: {
    ...mapGetters({
      windowSize: 'shared/windowSize'
    })
  },
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style scoped>
</style>
